import React from "react";
import { Accordion } from "../../components";

const SectionFAQ = ({ data }) => {
  return (
    <div className="bg-service-faq bg-lightblue-1 flex justify-center md:py-[100px] py-[60px] w-full relative">
      <div className="max-w-screen-xl flex flex-col gap-10 text-left w-full items-center px-5 xl:px-0">
        <p className="text-5xl">Frequently Asked Questions</p>
        <p className="text-xl text-justify">
          We understand you might have questions about our home cleaning
          services. Below, we've addressed some of the most common inquiries to
          help you make an informed decision. If you have any other questions or
          need further information, feel free to contact us!
        </p>
        <div className="flex flex-col gap-4 md:w-3/4 w-full items-center">
          {data.map((faq, index) => (
            <Accordion title={faq.q} content={faq.a} key={index} />
          ))}
        </div>
        <img
          src="/assets/images/services/left-arrows.png"
          alt="left-arrows"
          className="lg:w-[180px] w-[100px] h-auto absolute left-0 bottom-5 hidden md:block"
        />
        <img
          src="/assets/images/services/right-arrows.png"
          alt="right-arrows"
          className="lg:w-[152px] w-[80px] h-auto absolute right-0 top-10  md:block"
        />
      </div>
    </div>
  );
};

export default SectionFAQ;
